import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { hot } from 'react-hot-loader/root';
import { compose } from 'redux';

import { DevelopersCompanyContext } from 'common/containers/DevelopersCompanyContainer';
import { ViewerContext } from 'common/containers/ViewerContainer';
import IdentifyCompaniesSnippet from 'common/developers/docs/sdk/snippets/IdentifyCompaniesSnippet';
import MultiLanguageCodeBlock from 'common/developers/docs/widget/MultiLanguageCodeBlock';
import InstallCompaniesDocsHelmet from 'common/helmets/InstallCompaniesDocsHelmet';
import withContexts from 'common/util/withContexts';

import 'css/components/developers/docs/install/_IdentifyDocs.scss';

class CompaniesDocs extends Component {
  static propTypes = {
    company: PropTypes.object,
    viewer: PropTypes.object,
  };

  renderCompanyPicker() {
    const { company, viewer } = this.props;
    if (company?._id) {
      return null;
    }

    if (!viewer || viewer.loggedOut) {
      return (
        <div className="description">
          <span className="bold">To find your appID</span>, log in above. You'll see your appID
          pre&#8209;filled in the code&nbsp;snippet.
        </div>
      );
    }
  }

  renderSnippet() {
    const { company } = this.props;
    if (!company?._id) {
      return IdentifyCompaniesSnippet;
    }

    return IdentifyCompaniesSnippet.replace('YOUR_APP_ID', company._id);
  }

  render() {
    return (
      <div className="identifyDocs">
        <InstallCompaniesDocsHelmet />
        <div className="heading">Add Company Data</div>
        <div className="description">
          Is your product made for other businesses? Then you likely have multiple user accounts
          associated with each&nbsp;company.
        </div>
        <div className="description">
          You can send company data to Canny when you identify users. This way, we'll also track
          your companies and surface this data throughout&nbsp;Canny.
        </div>
        {this.renderCompanyPicker()}
        <MultiLanguageCodeBlock
          blocks={[
            {
              code: this.renderSnippet(),
              language: 'js',
            },
          ]}
          showSelector={false}
        />
      </div>
    );
  }
}

export default compose(
  withContexts({
    company: DevelopersCompanyContext,
    viewer: ViewerContext,
  }),
  hot,
)(CompaniesDocs);
